/**
 * SuperBrain — Cancel Account Deletion
 *
 * Public token-redeem page reached from the "Cancel Deletion" email link.
 * No login required (a logged-out user with a stale JWT can still recover
 * their account by clicking the email link).
 *
 * © 2026 A-1 Affiliate Marketing LLC
 */

import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import './AuthPage.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const API = `${BACKEND_URL}/api`;

const CancelDeletionPage = () => {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [state, setState] = useState('working'); // working | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setState('error');
      setMessage('Missing cancellation token. Please use the link from your email.');
      return;
    }
    (async () => {
      try {
        const r = await axios.post(`${API}/auth/cancel-deletion`, { token });
        setState('success');
        setMessage(r?.data?.message || 'Account deletion cancelled.');
      } catch (e) {
        setState('error');
        const detail = e?.response?.data?.detail;
        setMessage(
          typeof detail === 'string'
            ? detail
            : 'Could not cancel the deletion. The link may have expired.'
        );
      }
    })();
  }, [token]);

  return (
    <div className="auth-page" data-testid="cancel-deletion-page">
      <div className="auth-container">
        <div className="auth-header">
          <h1>SuperBrain</h1>
          <p className="auth-subtitle">Cancel Account Deletion</p>
        </div>

        <div className="auth-form" data-testid={`cancel-deletion-${state}`}>
          {state === 'working' && (
            <p className="auth-help" style={{ textAlign: 'center' }}>
              Cancelling your account deletion…
            </p>
          )}
          {state === 'success' && (
            <div className="auth-info" style={{ textAlign: 'center', fontSize: '1.05rem' }}>
              ✓ {message}
            </div>
          )}
          {state === 'error' && (
            <div className="auth-error" style={{ textAlign: 'center' }}>
              {message}
            </div>
          )}
          <Link
            to="/"
            className="auth-submit"
            style={{
              display: 'block',
              textAlign: 'center',
              textDecoration: 'none',
              marginTop: '1.5rem',
            }}
            data-testid="cancel-deletion-home"
          >
            Back to SuperBrain
          </Link>
        </div>

        <div className="auth-footer">
          <p>✝ GOD BLESS EVERYONE ✝</p>
          <p className="auth-copyright">© 2026 A-1 Affiliate Marketing LLC</p>
        </div>
      </div>
    </div>
  );
};

export default CancelDeletionPage;
